"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalSchema = void 0;
exports.findSignalIdBySignalName = findSignalIdBySignalName;
exports.findSignalNameBySignalId = findSignalNameBySignalId;
const zod_1 = require("zod");
const SignalBlockInfo_1 = require("./SignalBlockInfo");
const metadata_1 = require("./metadata");
const SignalAttributes_1 = require("./SignalAttributes");
const SignalDirection_1 = require("./SignalDirection");
const SignalDriveMode_1 = require("./SignalDriveMode");
const SignalId_1 = require("./SignalId");
const DifferentialPair_1 = require("./DrawingModels/DifferentialPair");
const ILogger_1 = require("../ILogger");
const SignalFloatingBehavior_1 = require("./SignalFloatingBehavior");
const IExternalComponent_1 = require("../FunctionalModels/IExternalComponent");
exports.SignalSchema = zod_1.z.object({
    id: SignalId_1.SignalIdSchema,
    name: zod_1.z.string(),
    blockInfo: zod_1.z.lazy(() => SignalBlockInfo_1.SignalBlockInfoSchema).optional(),
    padRefs: zod_1.z.string().array(),
    pinRefs: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]).array(),
    signalDirection: zod_1.z.lazy(() => SignalDirection_1.SignalDirectionSchema).optional(),
    attributes: zod_1.z.lazy(() => SignalAttributes_1.SignalAttributesSchema).optional(),
    description: zod_1.z.string().optional(),
    modelSignal: SignalId_1.SignalIdSchema.optional(),
    metadata: metadata_1.MetadataSchema.optional(),
    diffPair: DifferentialPair_1.DifferentialPairSchema.optional(),
    supportedDriveModes: SignalDriveMode_1.SignalDriveModeDefinitionSchema.array().optional(),
    floatingBehavior: zod_1.z.nativeEnum(SignalFloatingBehavior_1.SignalFloatingBehavior).optional(),
    ties: IExternalComponent_1.IExternalComponentSchema.array().optional(),
    isCadstromInternal: zod_1.z.boolean().optional(),
});
function findSignalIdBySignalName(signalName, signals, logger = (0, ILogger_1.generateCompatibleConsoleLogger)()) {
    const matchingSignals = signals.filter((signal) => signal.name === signalName);
    if (matchingSignals.length === 0) {
        logger.warn('FindSignalIdBySignalName_MatchNotFound', {
            signalName,
            availableSignalNames: signals.map((s) => s.name),
        });
        return null;
    }
    if (matchingSignals.length > 1) {
        logger.warn('FindSignalIdBySignalName_DuplicateSignalName', {
            signalName,
            matchingSignalIds: matchingSignals.map((s) => s.id),
            message: 'Multiple signals found with same name, using first occurrence',
        });
    }
    return String(matchingSignals[0].id);
}
function findSignalNameBySignalId(signalId, signals, logger = (0, ILogger_1.generateCompatibleConsoleLogger)()) {
    const matchingSignal = signals.find((signal) => String(signal.id) === String(signalId));
    if (!matchingSignal) {
        logger.warn('FindSignalNameBySignalId_MatchNotFound', {
            signalId,
            availableSignalIds: signals.map((s) => s.id),
        });
        return null;
    }
    return matchingSignal.name;
}
//# sourceMappingURL=Signal.js.map